import React from "react";

export default function UserRegister() {
    return (
        <div className="card">
            <h1>Registrieren</h1>

            <p className="muted">
                Hier entsteht später der persönliche Registrierungsbereich für Serien, Events oder Fahrerprofile.
            </p>

            <div className="alert alert--ok" style={{ marginTop: 16 }}>
                Platzhalter: Der Discord Account ist bereits angemeldet. Hier kommen später RaceVision-spezifische Registrierungen rein.
            </div>
        </div>
    );
}